import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { SnackbarContent, useSnackbar } from 'notistack';
import React, { forwardRef, useCallback, useState } from 'react';

const WrongParamsSnackbar = forwardRef(({ id, ...props }, ref) => {
     const { closeSnackbar } = useSnackbar();
     const [expanded, setExpanded] = useState(false);

     const handleExpandClick = useCallback(() => {
          setExpanded((oldExpanded) => !oldExpanded);
     }, []);

     const handleDismiss = useCallback(() => {
          closeSnackbar(id);
     }, [id, closeSnackbar]);

     return (
          <SnackbarContent
               ref={ref}
               sx={{
                    minWidth: { sm: '344px !important' },
               }}
          >
               <Card sx={{ width: '100%', backgroundColor: '#FF6961' }}>
                    <CardActions
                         sx={{
                              padding: '8px 8px 8px 16px',
                              justifyContent: 'space-between',
                         }}
                    >
                         <Typography variant="body" sx={{ color: '#FFF' }}>
                              {props.message}
                         </Typography>
                         <div>
                              <IconButton
                                   aria-label="Show more"
                                   size="small"
                                   sx={{
                                        padding: '8px 8px',
                                        color: '#FFF',
                                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'all .2s',
                                   }}
                                   onClick={handleExpandClick}
                              >
                                   <ExpandMoreIcon />
                              </IconButton>
                              <IconButton
                                   size="small"
                                   sx={{ padding: '8px 8px', color: '#FFF' }}
                                   onClick={handleDismiss}
                              >
                                   <CloseIcon fontSize="small" />
                              </IconButton>
                         </div>
                    </CardActions>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                         <Paper sx={{ backgroundColor: '#fff', padding: 2 }}>
                              <Typography gutterBottom variant="body" sx={{ color: '#000', display: 'block' }}>
                                   Errors Received:
                              </Typography>
                              <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
                                   {props.error?.trace?.originalException?.details.map((error, index) => (
                                        <Typography key={index} variant="body" sx={{ color: '#000' }}>
                                             {error.message}
                                        </Typography>
                                   ))}
                              </Stack>
                         </Paper>
                    </Collapse>
               </Card>
          </SnackbarContent>
     );
});

WrongParamsSnackbar.displayName = 'WrongParamsSnackbar';

export default WrongParamsSnackbar;
